var urlParams = new URLSearchParams(window.location.search);
var discountCode = urlParams.get('utm_source');

if (discountCode === 'app') {

  console.log('Medskin Beauty app loaded');
  sessionStorage.setItem("msbapp", "true");

  // global.js theme.liquid and customapp.js/css
  if (localStorage.getItem('shopify-section-template--14802253086784__rich_text_QL3BKc') === null) {
    document.querySelector("#shopify-section-template--14802253086784__rich_text_QL3BKc").style.display = "block"
  }

  // Update the 'data-sticky-behavior' attribute dynamically
  const stickyElement = document.getElementById('MainHeader');
  stickyElement.setAttribute('data-sticky-behavior', 'fixed');

  var code = 'P84FB74BDMW1';

  // Save the discount code as a session cookie
  document.cookie = `discount_code=${code}; path=/`;

  // Send GET request to "/discount/[discountcode]"
  fetch(`/discount/${code}`)
  .then(function() {

    // After the discount code has been applied, force the cart to update so the discount is visible for anything that calls the .cart.json file e.g. an AJAX draw cart. 
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: {},
      }),
    });
  })
  .catch(function(error) {
    console.error('Error:', error);
  });
  
}